import type { FC } from 'react'
import { useState } from 'react'

import { Input } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import EyeOffIcon from 'mdi-react/EyeOffOutlineIcon'
import EyeIcon from 'mdi-react/EyeOutlineIcon'
import { twJoin } from 'tailwind-merge'

import { useTranslation } from '@/components/i18n/hooks'
import { useIsThreeStepIT } from '@/hooks/user'

const PasswordView: FC = () => {
  const translate = useTranslation()
  const isThreeStepIT = useIsThreeStepIT()

  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <Field name="password">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          capitalizeLabel
          id="password"
          type={isPasswordVisible ? 'text' : 'password'}
          ariaLabel={translate('Passord')}
          marginBottom={16}
          error={meta.error}
          touched={meta.touched}
          placeholder={translate('Skriv inn passord')}
          RightElement={
            isPasswordVisible ? (
              <Button
                className={twJoin(
                  'm-0 border-none bg-transparent p-0 shadow-none',
                  isThreeStepIT
                    ? 'text-threeStepIT hover:text-threeStepIT-seaMistPrimary-hover active:text-threeStepIT-seaMistPrimary-active focus:text-threeStepIT-seaMistPrimary-active'
                    : 'text-gray-600 hover:text-gray-700',
                  isThreeStepIT &&
                    meta.error &&
                    meta.touched &&
                    'text-threeStepIT-failure hover:text-threeStepIT-failure-hover active:text-threeStepIT-failure-active focus:text-threeStepIT-failure-active'
                )}
                onClick={() => setIsPasswordVisible(false)}
                Icon={<EyeOffIcon className="w-6" />}
              />
            ) : (
              <Button
                className={twJoin(
                  'm-0 border-none bg-transparent p-0 shadow-none',
                  isThreeStepIT
                    ? 'text-threeStepIT hover:text-threeStepIT-seaMistPrimary-hover active:text-threeStepIT-seaMistPrimary-active focus:text-threeStepIT-seaMistPrimary-active'
                    : 'text-gray-600 hover:text-gray-700',
                  isThreeStepIT &&
                    meta.error &&
                    meta.touched &&
                    'text-threeStepIT-failure hover:text-threeStepIT-failure-hover active:text-threeStepIT-failure-active focus:text-threeStepIT-failure-active'
                )}
                Icon={<EyeIcon className="w-6" />}
                onClick={() => setIsPasswordVisible(true)}
              />
            )
          }
          {...field}
        />
      )}
    </Field>
  )
}

export default PasswordView
